import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_staging/6a0e1e772ab6ae0014be2aea/vaultis/node_modules/lucide-react/dist/esm/Icon.mjs");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/download_staging/6a0e1e772ab6ae0014be2aea/vaultis/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/download_staging/6a0e1e772ab6ae0014be2aea/vaultis/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_staging/6a0e1e772ab6ae0014be2aea/vaultis/src/app/components/HomepageNav.tsx");
